import React, { useState } from 'react';
import { Button, makeStyles } from '@fluentui/react-components';
import {
    Menu,
    MenuTrigger,
    MenuPopover,
    MenuList,
    MenuItem,
} from '@fluentui/react-components';
import { Add12Regular, MoreHorizontal20Regular, SubtractCircleFilled } from '@fluentui/react-icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../../context/AppContext';
//import styles from './Pinned.module.css'; // Assuming you have a CSS file for additional styles
import "./Pinned.css";

interface PinnedButtonsProps {
  // You can extend this later to accept additional props
}


const PinnedButtons: React.FC = () => {
  const navigate = useNavigate();
  const {
    pinnedApps,
    unpinApp,
    isEditing,
    setIsEditing,
    editPromptClicked,
    setEditPromptClicked,
  } = useAppContext();

  const toggleEdit = () => {
    if (isEditing) {
      setIsEditing(false);
      setEditPromptClicked(false);
    } else {
      setIsEditing(true);
    }
  };

  const showPrompt = pinnedApps.length === 0 && !editPromptClicked;
  const showPlaceholder = pinnedApps.length === 0 && editPromptClicked;

  return (
    <>
      <div className="header">
        <h2>Pinned</h2>
        {(pinnedApps.length > 0 || editPromptClicked) && (
          <span className="edit" onClick={toggleEdit} role="button">
            {isEditing ? 'Done' : 'Edit'}
          </span>
        )}
      </div>

      <div className="container">
        {pinnedApps.length > 0 ? (
          pinnedApps.map((btn) => (
            <div className="btnContainer" key={btn.label}>
              <div className="appCard">
              <Button
                className="btnContent"
                icon={
                  <img
                    src={btn.icon}
                    alt={btn.label}
                    style={{ width: '24px', height: '24px' }}
                  />
                }
                size="small"
                appearance="transparent"
                onClick={() => navigate(btn.path)}
              />
              {isEditing && (
                <div className="floatingAdd subtracts">
                  <Button
                    icon={<SubtractCircleFilled />}
                    onClick={() => unpinApp(btn.label)}
                  />
                </div>
              )}
              <div className="label">{btn.label}</div>
              </div>
            </div>
          ))
        ) : showPlaceholder ? (
          <div className="placeholder"></div>
        ) : showPrompt ? (
          <div
            className="clientNopinned"
            onClick={() => {
              setIsEditing(true);
              setEditPromptClicked(true);
            }}
          >
            <Button icon={<Add12Regular />} />
            <span className="textContent">
              Pinned apps appear here for quick access
            </span>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default PinnedButtons;
